// extracted by mini-css-extract-plugin
module.exports = {"form":"BoameoooServices_form__2cyLn","input":"BoameoooServices_input__3SH0N","textarea":"BoameoooServices_textarea__3A7YH","submitButton":"BoameoooServices_submitButton__35oe6"};